import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/proposal-builder/templates')({
  component: ProposalTemplatesLayoutRoute,
})

function ProposalTemplatesLayoutRoute() {
  return <Outlet />
}